/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all animation APIs of the animation browser package.
 */
export {AnimationDriver, NoopAnimationDriver} from './render/animation_driver';
export * from './private_export';
